import React from 'react';

export default function TwoColumnSectionOrganizers({
  sections,
  TeamCard,
  ibmMessage,
}) {
  return (
    <div>
      {sections.map((section) => {
        const isIBM = section.title === 'IBM Team';

        if (isIBM) {
          // One thin line BEFORE, message styled, NO line after
          return (
            <section key={section.title} className="mt-10">
              <h2 className="section-title">IBM Team</h2>
              <div className="single-rule" />
              <p className="ibm-msg">
                {ibmMessage}
              </p>
            </section>
          );
        }

        // Split members by campus
        const left  = section.items.filter((p) => (p.campus || 'UMD') === 'UMD');
        const right = section.items.filter((p) => (p.campus || 'USC') === 'USC');

        return (
          <section key={section.title} className="mt-10">
            <h2 className="section-title">{section.title}</h2>

            {/* Two campus columns */}
            <div className="two-col-grid mb-6">
              {/* Masonry (packed) lists per campus */}
              <div className="campus-grid">
                {left.map((m, i) => (
                  <TeamCard key={m.id ?? `l-${i}`} member={m} />
                ))}
              </div>
              <div className="campus-grid">
                {right.map((m, i) => (
                  <TeamCard key={m.id ?? `r-${i}`} member={m} />
                ))}
              </div>
            </div>

            {/* single separator only at END of section */}
            <div className="single-rule" />
          </section>
        );
      })}
    </div>
  );
}
